import { createSlice } from '@reduxjs/toolkit';

import type { OrganizationResponse } from './types';

export const slice = createSlice({
    initialState: {
        currentOrganization: undefined as OrganizationResponse | undefined
    },

    name: 'useCurrentOrganization',

    reducers: {
        currentOrganization: (state, action) => {
            state.currentOrganization = action.payload;
        }
    }
});

export default slice.reducer;
